import {ErrorUtil} from "base/utilities";
import styled from "@mui/material/styles/styled";
import Alert from "@mui/material/Alert";

const AlertStyled = styled(Alert)(({theme}) => ({
    whiteSpace: "pre-line",
}));

const AlertError = ({error, ...props}) => {
    return error ? (
        <AlertStyled severity="error" sx={{width: "100%"}} {...props}>
            {ErrorUtil.getMessage(error)}
        </AlertStyled>
    ) : null;
};

export default AlertError;
